module.exports = __webpack_public_path__ + "img/arrow.e5ef35ad.png";